'use client';

import { flex, text, vstack } from '@onbeam/business-styled-system/patterns';
import Image from 'next/image';
import { css } from '@onbeam/business-styled-system/css';
import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { quotes } from './EcosystemQuotes.data';

const CARD_OFFSET = 17;
const ANIMATION_DURATION = 0.75;
const INTERVAL_DURATION = 4000;

export const EcosystemQuotes = () => {
  const [stack, setStack] = useState(quotes);

  useEffect(() => {
    const interval = setInterval(() => {
      setStack((currentStack) => {
        const newStack = [...currentStack];
        const newLast = newStack.shift()!;
        return [...newStack, newLast];
      });
    }, INTERVAL_DURATION);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const substack = stack.slice(0, 4);

  return (
    <div
      className={flex({
        justify: 'center',
        position: 'relative',
        w: 'full',
        h: '[8.1875rem]',
        md: {
          h: '[8.5625rem]',
        },
      })}
    >
      <AnimatePresence>
        {substack.map((quote, index) => (
          <motion.div
            key={quote.name}
            className={flex({
              position: 'absolute',
              bottom: '0',
              gap: '4',
              p: '5',
              w: 'full',
              maxW: '[34.6875rem]',
              h: '[8.75rem]',
              bg: 'mono.primaryFg',
              border: '1px solid',
              borderColor: 'opacity.lg',
              shadow: 'md',
              rounded: 'md',
              overflow: 'hidden',
            })}
            style={{
              zIndex: substack.length - index,
            }}
            animate={{
              y: index * CARD_OFFSET,
              scale: 1 - index * 0.1,
              opacity: index === substack.length - 1 ? 0 : 1,
            }}
            initial={false}
            transition={{
              duration: ANIMATION_DURATION,
              ease: 'easeInOut',
            }}
            exit={{
              zIndex: substack.length + 1,
              y: (substack.length - 1) * CARD_OFFSET,
              scale: 0.8,
              opacity: 0,
            }}
          >
            <Image
              src={quote.image}
              alt=""
              width={56}
              height={56}
              className={css({ rounded: 'xs', w: '[3.5rem]', h: '[3.5rem]' })}
            />
            <div className={vstack({ gap: '2', overflow: 'hidden' })}>
              <p
                className={text({
                  style: 'body-md',
                  lineClamp: 3,
                  md: { textStyle: 'body-lg' },
                })}
                title={quote.text}
              >
                “{quote.text}”
              </p>
              <div
                className={flex({
                  mt: 'auto',
                  gap: '2',
                  textStyle: 'body-sm',
                  whiteSpace: 'nowrap',
                })}
              >
                <span>{quote.name}</span>
                <span
                  className={text({
                    color: 'mono.tertiary',
                    truncate: true,
                  })}
                >
                  {quote.position}
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};
